module.exports = __webpack_public_path__ + "img/xsede-full-color.original.745b45a3.png";